/* @flow */
import color from 'color';

export default {
  opacity: (colorString: string, alpha: number) => {
    return color(colorString)
      .alpha(alpha)
      .rgb()
      .toString();
  },
  lighten: (colorString: string, lightness: number) => {
    return color(colorString)
      .lighten(lightness)
      .rgb()
      .toString();
  },
  darken: (colorString: string, darkness: number) => {
    return color(colorString)
      .darken(darkness)
      .rgb()
      .toString();
  },
  IndigoDarkest: '#1B1E33',
  IndigoDarker: '#262E5C',
  IndigoDark: '#283060',
  Indigo: '#3B4478',
  IndigoLight: '#969EBD',
  IndigoLighter: '#F5F5F8',
  IndigoLightest: '#B4BAD3',
  Violet: '#505FB4',
  Yellow: '#FFF055',
  YellowLight: '#FFF591',
  Black: '#1B1E33',
  Gray: '#808080',
  GrayAlt1: '#848793',
  GrayLight: '#F3F3F6',
  GrayLightest: '#FBFBFB',
  Green: '#0A0',
  White: '#fff',
  Red: '#FF7A5F',
  RedError: '#DE615E',
  Twitter: '#4A90E2',
  Facebook: '#415088',
  PublicStorage: '#FF6600',
  ExtraSpaceStorage: '#90C900',
  A1Storage: '#006BBB',
  Mercury: '#E8E8E8',
  AthensGray: '#F7F7F8',

  get Divider() {
    return this.opacity(this.Indigo, 0.05);
  },
};



// WEBPACK FOOTER //
// ./src/ui/constants/Colors.js